<template>
  <v-form lazy-validation @submit.prevent="onLogin" id="loginForm" ref="form">
    <v-card-text class="form-content">
      <v-text-field
        label="Usuário (e-mail)"
        name="login"
        type="text"
        v-model="payload.email"
        :rules="userRules"
        required
        background-color="white"
        filled
        hide-details="auto"
        persistent-placeholder
        class="mb-4"
        autocomplete="username"
      ></v-text-field>

      <v-text-field
        v-if="!showNewPassword"
        id="password"
        label="Senha"
        name="password"
        type="password"
        v-model="payload.senha"
        :rules="passwordRules"
        required
        background-color="white"
        filled
        append-icon="mdi-eye-off"
        hide-details="auto"
        persistent-placeholder
        class="mb-5"
        autocomplete="current-password"
        @click:append="showNewPassword = true"
      ></v-text-field>
      <v-text-field
        v-if="showNewPassword"
        id="password"
        label="Senha"
        name="password"
        type="text"
        v-model="payload.senha"
        :rules="passwordRules"
        required
        background-color="white"
        filled
        append-icon="mdi-eye"
        hide-details="auto"
        persistent-placeholder
        class="mb-5"
        autocomplete="current-password"
        @click:append="showNewPassword = false"
      ></v-text-field>
    </v-card-text>

    <v-card-actions class="px-0 pb-0">
      <v-row>
        <v-col>
          <div class="text-center">
            <v-btn
              color="primary"
              type="submit"
              id="btnEntrar"
              class="modern-btn-login"
              size="large"
              block
            >
              ENTRAR
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-card-actions>

    <v-card-actions class="forgot-password-section px-0 pt-4">
      <v-row>
        <v-col>
          <div class="text-center">
            <p class="forgot-password-text mb-2">NÃO SABE SUA SENHA?</p>
            <v-btn
              variant="outlined"
              color="primary"
              :href="'#/auth/lost-password'"
              class="modern-btn-forgot"
            >
              CLIQUE AQUI
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-card-actions>
  </v-form>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Auth from "@/Auth.js";
import { configuracoesAPI } from "@/modules/configuracao";
import { groupsPermissionAPI } from "@/modules/groups";

export default {
  computed: {
    ...mapGetters([
      "token",
      "forcedLogout",
      "isAT",
      "isSala",
      "isGov",
      "isTur",
    ]),
  },
  data() {
    return {
      payload: {},
      passwordRules: [(v) => !!v || "O campo senha é obrigatório"],
      userRules: [(v) => !!v || "O campo usuário é obrigatório"],
      valid: true,
      expired: Auth.getItem("expired"),
      lastRoute: Auth.getItem("last_route") || null,
      showNewPassword: false,
    };
  },
  methods: {
    ...mapActions([
      "setToken",
      "setConfig",
      "setUser",
      "setIsLogged",
      "setLoading",
      "setUf",
      "setAnalista",
      "setAD",
      "setForcedLogout",
      "setFullAdmin",
      "setGroupsConfig",
    ]),
    async check() {
      const isValid = await this.$refs.form.validate();
      return isValid;
    },
    async onLogin() {
      var isValid = await this.check();
      if (!isValid) return;
      this.setLoading(true);
      this.$http
        .post("api/login", this.payload)
        .then(async ({ data }) => {
          if (data.user) {
            delete data.user.senha;
            const mappedUser = {
              ...data.user,
              permissoes: data.user.permissoes.map((item) => ({
                ...item,
                municipio: {},
              })),
            };
            this.setUser(mappedUser);
            this.setForcedLogout(false);
            if (data.user.email === "admin@admin.com.br")
              this.setFullAdmin(true);
            this.setToken(data.accessToken);

            this.$http.defaults.headers.common[
              "Authorization"
            ] = `Bearer ${this.token}`;

            const config = await configuracoesAPI.get();
            const groupPermission = await groupsPermissionAPI.getByGroup(
              data.user.grupo.usuarioGrupoId
            );

            var uf = config.data.filter((item) => item.nome === "sigla")[0]
              .valor;

            this.setUf(uf);

            const configData = config.data.find(
              (item) => item.configuracaoId == 1
            );

            const propostaSolucaoIdObrigatorio = config.data.find(
              (item) => item.nome == "propostaSolucaoIdComboEssencial"
            );

            delete configData.relatorioFinal;
            this.setConfig(configData);
            this.setGroupsConfig(groupPermission.data);

            this.$notification.success("Logado com sucesso!", { timer: 3 });
            this.$forceUpdate();
            if (
              this.expired === true &&
              this.forcedLogout === false &&
              this.lastRoute !== "/auth/login"
            ) {
              Auth.setItem("expired", false);
              this.$router.push(this.lastRoute);
            } else {
              this.$router.push("/cidade");
            }
          } else {
            console.log("Ocorreu um erro: usuario retornado foi : ", data);

            this.$notification.error(
              "Aconteceu um problema, contate o administrador do sistema",
              { timer: 10 }
            );
          }
          this.setLoading(false);
        })
        .catch((err) => {
          console.log("Erro ao fazer login: ", err);
          this.setLoading(false);

          if (err.response && err.response.data.usuarioBloqueado) {
            this.$notification.error(err.response.data.message, {
              timer: 10,
            });
          } else if (err.response && err.response.data.credencialErrada) {
            this.$notification.error(
              "Por gentileza, verifique as credenciais digitadas",
              { timer: 5 }
            );
          } else {
            this.$notification.error(
              "Ocorreu um erro, entre em contato com o administrador do sistema.",
              { timer: 10 }
            );
          }
          this.setForcedLogout(true);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.form-content {
  padding: 0 !important;
}

.modern-input {
  ::v-deep .v-input__slot {
    border-radius: 12px !important;
    border: 1px solid #e5e7eb !important;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05) !important;

    &:hover {
      border-color: var(--corPrimaria, #1976d2) !important;
    }
  }

  ::v-deep .v-input--is-focused .v-input__slot {
    border-color: var(--corPrimaria, #1976d2) !important;
    box-shadow: 0 0 0 2px rgba(25, 118, 210, 0.1) !important;
  }

  ::v-deep .v-text-field input {
    color: #374151 !important;
    font-size: 16px;
  }

  ::v-deep .v-label {
    color: #6b7280 !important;
    font-size: 14px;
  }
}

.modern-btn-login {
  background: linear-gradient(
    135deg,
    var(--corPrimaria, #1976d2) 0%,
    var(--corPrimaria, #1976d2) 100%
  ) !important;
  color: white !important;
  border-radius: 12px !important;
  font-weight: 600 !important;
  font-size: 16px !important;
  text-transform: none !important;
  padding: 16px 24px !important;
  min-height: 56px !important;
  box-shadow: 0 6px 20px rgba(25, 118, 210, 0.3) !important;
  transition: all 0.3s ease !important;

  &:hover {
    box-shadow: 0 8px 25px rgba(25, 118, 210, 0.4) !important;
    transform: translateY(-2px) !important;
    filter: brightness(1.1) !important;
  }

  &:active {
    transform: translateY(0) !important;
  }
}

.forgot-password-section {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%) !important;
  border-radius: 16px !important;
  margin: 24px 8px 0 8px !important;
  padding: 20px 16px 16px 16px !important;
  border: 1px solid rgba(0, 0, 0, 0.05) !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04) !important;
}

.forgot-password-text {
  color: #6b7280 !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  margin-bottom: 16px !important;
}

.modern-btn-forgot {
  border-radius: 12px !important;
  font-weight: 500 !important;
  font-size: 14px !important;
  text-transform: none !important;
  padding: 22px 24px !important;
  width: 100% !important;
  transition: all 0.3s ease !important;
  box-shadow: none;

  &:hover {
    background: var(--corPrimaria, #1976d2) !important;
    color: white !important;
    box-shadow: 0 4px 12px rgba(25, 118, 210, 0.25) !important;
  }
}

// Responsividade
@media screen and (max-width: 480px) {
  .modern-btn-login {
    font-size: 15px !important;
    padding: 14px 20px !important;
    min-height: 52px !important;
  }

  .forgot-password-text {
    font-size: 13px;
  }

  .modern-btn-forgot {
    font-size: 13px !important;
    min-height: 44px !important;
    padding: 10px 24px !important;
  }

  .forgot-password-section {
    margin: 20px 4px 0 4px !important;
    padding: 16px 12px 12px 12px !important;
  }
}
</style>
